import { useState } from 'react';

import { Button, Modal } from '../components';

type UseConfirmParams = {
  text?: string;
  loading?: boolean;

  onConfirm: () => void;
};

type Result = {
  element: React.ReactNode;
  isOpened: boolean;
  close: () => void;
  open: (params?: UseConfirmParams) => void;
};

export const useConfirm = (params?: UseConfirmParams): Result => {
  const [isOpened, setIsOpened] = useState(false);
  const [override, setOverride] = useState<UseConfirmParams>();

  const settings: UseConfirmParams = override ||
    params || { onConfirm: () => void 0 };

  const handleClose = () => {
    setIsOpened(false);
    setOverride(undefined);
  };
  const handleOpen = (override?: UseConfirmParams) => {
    setIsOpened(true);
    setOverride(override);
  };

  return {
    element: (
      <Modal
        size="small"
        open={isOpened}
        title="Confirm"
        onClose={handleClose}
        headerActions={
          <>
            <Button
              label="Yes"
              type="primary"
              loading={settings?.loading}
              onClick={settings.onConfirm}
            />
            <Button onClick={handleClose}>Cancel</Button>
          </>
        }
      >
        <div className="text-medium">{settings.text}</div>
      </Modal>
    ),
    isOpened,

    close: handleClose,
    open: handleOpen,
  };
};
